<template>
  <div
    id="triple-points-section"
    class="padding-s triple-points-container lh-container-custom-gutters"
    :class="tierValues.TIER_BG_COLOR"
  >
    <div class="grid-x">
      <!-- TriplePointDescription -->
      <div class="cell large-5 margin-top-s medium-padding-right-xs">
        <h3 :class="tierValues.TIER_COLOR_VALUE">
          {{ TRIPLE_POINTS_DAYS.TITLE_TEXT }}
        </h3>
        <div class="grid-x margin-top-m small-margin-bottom-m triple-points-section-divider">
          <!-- 3X content -->
          <div class="margin-right-xs large-2 medium-1 small-2">
            <img
              :src="
                tierValues.NAME === 'LOYALLIST'
                  ? loyallistPerk
                  : tierValues.NAME === 'TOL'
                    ? tolThreeXPerk
                    : tierValues.NAME === 'UNL'
                      ? tolUnlThreeXperl
                      : ''
              "
              alt="loyaltyPerk"
              class="loyallist-3x-offer"
            />
          </div>
          <!-- 3X content Explaination -->
          <div class="large-9 medium-9 small-9">
            <!-- content Explaination with learn more link -->
            <div class="grid-y">
              <p>
                <span
                  v-if="triplePointUpgradeEnabled && (tierValues.NAME === 'TOL' || tierValues.NAME === 'UNL')"
                  class="points-highlight-text"
                  >{{ tierValues.DAYS_EACH_YEAR_ED }}</span
                >
                <span
                  v-else
                  class="points-highlight-text"
                  >{{ tierValues.DAYS_EACH_YEAR }}</span
                >
                {{ TRIPLE_POINTS_DAYS.TO_EARN_THROUGH_STORES }}
                <a
                  class="link-body triple-points-link"
                  :href="TRIPLE_POINTS_DAYS.LEARN_MORE_LINK"
                  target="_blank"
                  >{{ TRIPLE_POINTS_DAYS.LEARN_MORE }}</a
                >
              </p>
              <!-- TriplePoints expiry information -->
              <div class="margin-top-s small-padding-right-l medium-padding-right-z">
                <span class="body small">{{ TRIPLE_POINTS_DAYS.UNUSED_TRIPLE_POINT_DAYS }}{{ year2Digits }}</span>
                <button
                  class="tooltip-small tooltip-position"
                  @click.stop="openModal('triplePointTooltip', TRIPLE_POINTS_DAYS.TITLE_TEXT, 'triplePointTooltipOverlay', '', '44.60rem')"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Scheduled Days -->
      <div class="cell large-7 padding-s scheduled-days-section">
        <!-- lable for schedule days -->
        <div>
          <!-- Your Triple point day is today -->
          <div v-if="dayIsToday.includes(true)">
            <div>
              <p
                class="body large"
                :class="tierValues.TIER_COLOR_VALUE"
              >
                {{ TRIPLE_POINTS_DAYS.TPD_IS_TODAY }}
              </p>
            </div>
            <div class="body small margin-top-xxs">
              {{ TRIPLE_POINTS_DAYS.TPD_TODAY_SUB_INFO }}
            </div>
          </div>
          <div v-else>
            <template v-if="!triplePointUpgradeEnabled">
              <span
                class="body large"
                :class="tierValues.TIER_COLOR_VALUE"
                >{{ TRIPLE_POINTS_DAYS.YOU_HAVE }}</span
              ><span
                class="subtitle-1"
                :class="tierValues.TIER_COLOR_VALUE"
              >
                {{ pickYourDaySummaryVB.remainingDays }} </span
              ><span
                class="body large"
                :class="tierValues.TIER_COLOR_VALUE"
              >
                {{ TRIPLE_POINTS_DAYS.TRIPLE_POINT_TEXT }}
                {{ pickYourDaySummaryVB.remainingDays === 1 ? TRIPLE_POINTS_DAYS.REMAINING_DAY : TRIPLE_POINTS_DAYS.REMAINING_DAYS }}
                {{ TRIPLE_POINTS_DAYS.TPD_REMAINING }}</span
              >
            </template>
            <template v-else>
              <div class="info-line">
                <span
                  class="body large"
                  :class="tierValues.TIER_COLOR_VALUE"
                  >{{ TRIPLE_POINTS_DAYS.YOU_HAVE }}
                </span>
                <span
                  class="body large"
                  :class="tierValues.TIER_COLOR_VALUE"
                  >&nbsp;{{ pickYourDaySummaryVB.remainingDays }}&nbsp;</span
                >
                <span
                  class="body large"
                  :class="tierValues.TIER_COLOR_VALUE"
                  >{{ TRIPLE_POINTS_DAYS.UNUSED_TRIPLE_POINTS_TEXT_ED }}
                </span>
                <span
                  class="body large"
                  :class="tierValues.TIER_COLOR_VALUE"
                  >&nbsp;{{ pickYourDaySummaryVB.remainingDays === 1 ? TRIPLE_POINTS_DAYS.REMAINING_DAY : TRIPLE_POINTS_DAYS.REMAINING_DAYS }}.</span
                >
                <button
                  class="tooltip-small"
                  @click.stop="
                    openModal('triplePointUnusedTooltip', TRIPLE_POINTS_DAYS.TITLE_TEXT, 'triplePointUnusedTooltipOverlay', '', '44.60rem')
                  "
                ></button>
              </div>
            </template>
          </div>
        </div>
        <div class="margin-top-m">
          <p class="label">
            Scheduled Days (<span class="daysSelected">
              <template
                v-if="
                  pickYourDaySummaryVB.scheduledDays > pickYourDaySummaryVB.eligibleDays &&
                  pickYourDaySummaryVB.usedDays === pickYourDaySummaryVB.eligibleDays
                "
              >
                {{ pickYourDaySummaryVB.usedDays }}
              </template>
              <template v-else>
                {{ pickYourDaySummaryVB.scheduledDays }}
              </template> </span
            >/{{ pickYourDaySummaryVB.eligibleDays }})
          </p>
        </div>
        <!-- scheduled days date picker -->
        <div v-if="pickYourDaySummaryVB.pydDaysList">
          <div
            v-for="(day, index) in pickYourDaySummaryVB.pydDaysList"
            :key="index"
            :class="`large-${12 / pickYourDaySummaryVB.pydDaysList.length}`"
          >
            <div
              v-if="day.date || day.usedFlag"
              class="margin-top-s padding-bottom-xs scheduled-action-view schedule-day-view"
            >
              <div class="small-margin-bottom-xs medium-margin-bottom-z">
                <p
                  v-if="day.usedFlag"
                  class="body heavy past-scheduled-day-color"
                >
                  {{ day.formattedDate }}
                </p>
                <p
                  v-else-if="day.date"
                  class="body heavy scheduled-day-color"
                >
                  <span v-if="day.isToday">{{ TRIPLE_POINTS_DAYS.TPD_TODAY }} </span>{{ day.formattedDate }}
                </p>
              </div>
              <div
                v-if="!day.usedFlag"
                class="triple-points-section-divider"
              >
                <button
                  type="button"
                  class="margin-right-s tpd-action-buttons"
                  :aria-label="`${TRIPLE_POINTS_DAYS.RESCHEDULE} ${day.formattedDate}`"
                  @click.stop="openModal('reScheduleDateModal', TRIPLE_POINTS_DAYS.SCHEDULED_DAY, 'pickDateOverlay', day.date)"
                >
                  <span
                    class="margin-right-xxs calendar-filled"
                    aria-hidden="true"
                  ></span>
                  <span>{{ TRIPLE_POINTS_DAYS.RESCHEDULE }}</span>
                </button>
                <button
                  type="button"
                  class="tpd-action-buttons"
                  :aria-label="`${TRIPLE_POINTS_DAYS.REMOVE} ${day.formattedDate}`"
                  @click.stop="removeModal(day.date, 'removeDateModal', TRIPLE_POINTS_DAYS.REMOVE_DATE, 'removeDateOverlay')"
                >
                  <span
                    class="margin-right-xxs close"
                    aria-hidden="true"
                  ></span>
                  <span>{{ TRIPLE_POINTS_DAYS.REMOVE }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="margin-top-m">
          <button
            class="secondary button expanded"
            :disabled="pickYourDaySummaryVB.scheduledDays === pickYourDaySummaryVB.eligibleDays"
            @click.stop="openModal('pickDateModal', TRIPLE_POINTS_DAYS.SCHEDULED_DAY, 'pickDateOverlay')"
          >
            {{ TRIPLE_POINTS_DAYS.SCHEDULE_A_DAY }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, watch, ref, reactive } from 'vue';
import Moment from 'moment';
import { Cookie } from '@nuxt-common/util/app/utils/cookie';
import { TRIPLE_POINTS_DAYS, brand } from '../../config';
import getHeader from '../../utils/getHeader';
import { loadOverlayComponent } from '../../utils/loadOverlayComponent';
import loyallistPerk from '../../assets/images/Loyalty-Perks.svg';
import tolThreeXPerk from '../../assets/images/Tol-3x-offers.svg';
import tolUnlThreeXperl from '../../assets/images/Tol-Unl-3x-offers.svg';
import { useLoyaltyHubStore } from '../../stores/useLoyaltyHubStore.js';
import { useModalOverlayStore } from '../../stores/useModalOverlayStore';
import { useKillswitchesStore } from '../../stores/useKillswitchesStore';

const store = useLoyaltyHubStore();
const modalStore = useModalOverlayStore();
const killswitchesStore = useKillswitchesStore();

const summary = computed(() => store.unifiedLoyalty?.points?.loyaltyPointsResponse?.loyaltyInfo || {});
const tier = summary.value || {};
const year2Digits = new Moment(tier?.tierExpiryDate).format('YY');
const pickYourDays = computed(() => store.triplePointData || {});
const requestedDates = computed(() => store.requestedDates || {});
const overlayEvent = ref('');
const pickYourDaySummaryVB = reactive({});
const dayIsToday = ref([]);
const tierName = computed(() => store.tierName || '');
const tierValues = computed(() => TRIPLE_POINTS_DAYS.TIER_DETAILS[tierName.value] || {});
const triplePointUpgradeEnabled = computed(() => killswitchesStore.triplePointsDayBenefitUpdateEnabled === true);

const toggleModal = (val) => {
  modalStore.toggle(val);
};

const openModal = async (idVal, titleVal, componentPath, dateVal = '', widthVal = '') => {
  store.dateToDelete = dateVal || '';
  const component = await loadOverlayComponent(componentPath);
  let defaultWidth = '46%';
  if (componentPath === 'pickDateOverlay') {
    defaultWidth = 'fit-content';
  } else if (componentPath === 'removeDateOverlay') {
    defaultWidth = '32%';
  }
  modalStore.setModalOverlay({
    width: widthVal || defaultWidth,
    id: idVal,
    title: titleVal,
    component,
    props: {
      scheduleButtonText: idVal === 'reScheduleDateModal' ? 'RESCHEDULE' : 'SCHEDULE',
      modelIdVal: idVal,
    },
  });
  toggleModal(idVal);
};

const removeModal = (dateVal, idVal, titleVal, componentPath) => {
  openModal(idVal, titleVal, componentPath, dateVal);
};

const processScheduledDays = (pydAvailabilityList) => {
  pickYourDaySummaryVB.pydDaysList = [];
  dayIsToday.value = [];

  const pydScheduledDays = pydAvailabilityList.PADScheduledDays || [];
  for (let i = 0; i < pydAvailabilityList.eligibleDays; i += 1) {
    const scheduledDay = { ...(pydScheduledDays[i] || {}) };
    if (scheduledDay.date) {
      scheduledDay.formattedDate = new Moment(scheduledDay.date).format('dddd, MMMM DD');
      scheduledDay.isToday = new Moment().isSame(scheduledDay.date, 'day');
      scheduledDay.showScheduled = Object.keys(requestedDates.value).includes(scheduledDay.date);
    }
    pickYourDaySummaryVB.pydDaysList.push(scheduledDay);
    dayIsToday.value.push(scheduledDay.isToday);
  }
};

const updateSummaryFromOffers = (accountOffers, loyaltyId) => {
  const [pydAvailabilityList] = accountOffers.PADAvailability || [];
  if (!pydAvailabilityList) return;

  pickYourDaySummaryVB.loyaltyId = loyaltyId;
  pickYourDaySummaryVB.eligibleDays = pydAvailabilityList.eligibleDays;
  pickYourDaySummaryVB.remainingDays = pydAvailabilityList.remainingDays;
  pickYourDaySummaryVB.scheduledDays = pydAvailabilityList.scheduledDays;
  pickYourDaySummaryVB.usedDays = pydAvailabilityList.usedDays;
  pickYourDaySummaryVB.year = (pydAvailabilityList.year || '').toString().slice(-2);

  processScheduledDays(pydAvailabilityList);

  if (accountOffers.tierName?.length > 0) {
    pickYourDaySummaryVB.tierName = accountOffers.tierName;
  }
};

watch(pickYourDays, (newValue) => {
  if (!newValue || Object.keys(newValue).length === 0) return;

  const { accountOffers, loyaltyId } = newValue;
  if (!accountOffers) return;

  updateSummaryFromOffers(accountOffers, loyaltyId);

  if (overlayEvent.value === 'selectedDate' || overlayEvent.value === 'removedDate') {
    const selectedDate = [];
    accountOffers.PADAvailability?.[0]?.PADScheduledDays?.forEach((element) => {
      if (element.date) {
        selectedDate.push(new Moment(element.date).format('MM/DD/YYYY'));
      }
    });
  }
});

const fetchTriplePointData = async () => {
  const headers = await getHeader(Cookie, brand);
  return store.fetchTriplePoint({ headers });
};

onMounted(() => {
  // Calling dicount API to get the percentage for BCOM
  fetchTriplePointData();
});
</script>


<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/bcom/_confirmation-green-checkmark.scss';
@import '~@core/csg/src/scss/encodedIcons/bcom/_calendar-filled.scss';
@import '~@core/csg/src/scss/encodedIcons/bcom/_close.scss';
@import '~@core/csg/src/scss/encodedIcons/bcom/_tooltip-small.scss';

.scheduled-day-color {
  color: $green;
}

.past-scheduled-day-color {
  color: $gray-1-color;
}

.loyalty-color {
  background: $loyalty-bg-1-color;
}

.loyalty-upgrade-tier {
  background: $loyalty-bg-2-color;
}

.loyallist-tier-color {
  color: $loyalty-1-color;
}

.tol-tier-color {
  color: $loyalty-bg-3-color;
}

.unl-tier-color {
  color: $loyalty-4-color;
}

.tpd-action-buttons {
  display: flex;
  align-items: center;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: left;
}
.subtitle-1 {
  font-weight: 700;
  font-size: rem-calc(22);
}

.schedule-day-view {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dotted $gray-3-color;
}

.triple-points-section-divider {
  display: flex;
}
.tooltip-position {
  position: relative;
  top: rem-calc(7);
  display: inline-flex;
}
.scheduled-position {
  position: relative;
  bottom: rem-calc(6);
  color: $green;
}
.date-separator-space {
  justify-content: space-between;
}
.points-highlight-text {
  font-weight: $global-weight-bold;
}
.triple-points-link {
  white-space: nowrap;
}
.scheduled-days-section {
  background: $body-background;
}
@include breakpoint(small only) {
  .scheduled-action-view {
    flex-wrap: wrap;
  }
}
@include breakpoint(mlarge up) {
  .calendar-space {
    flex-basis: 48%;
  }
}
@include breakpoint(1251px up) {
  @include breakpoint(1353px down) {
    .medium-padding-right-z {
      padding-right: rem-calc(24) !important;
    }
  }
}
@include breakpoint(419px up) {
  @include breakpoint(471px down) {
    .medium-padding-right-z {
      padding-right: rem-calc(0) !important;
    }
  }
}
.lh-container-custom-gutters:deep() {
  margin-right: rem-calc(20);
  margin-left: rem-calc(20);
  @include breakpoint(small down) {
    margin-right: rem-calc(0);
    margin-left: rem-calc(0);
  }
}
.info-line {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
}
</style>